import React from 'react';
import { useNavigate } from 'react-router-dom';

const InscripcionEnviadaPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-blue-50 to-purple-50 flex items-center justify-center p-4">
      <div className="max-w-xl w-full relative overflow-hidden rounded-[2rem] bg-white/80 backdrop-blur-xl border border-white/50 shadow-2xl p-10 text-center">
        <h1 className="text-3xl text-neutral-700 mb-4">¡Gracias por inscribirte!</h1>
        <p className="text-neutral-600 mb-2">
          Te enviamos por mail la información para realizar el pago. Si no ves el mensaje en los próximos minutos, revisá la carpeta de spam o promociones.
        </p>
        <button
          onClick={() => navigate('/')}
          className="mt-6 px-6 py-3 rounded-xl bg-gradient-to-r from-green-400 to-blue-400 text-white shadow-lg hover:shadow-xl"
        >
          Volver al inicio
        </button>
      </div>
    </div>
  );
};

export default InscripcionEnviadaPage;


